import { useFetch } from 'hooks/use-fetch/use-fetch';
import { useQuery } from '@tanstack/react-query';
import { CompanyQueryKeys } from '../company.props';
import { companyRequestConfig } from 'request-config/company/company.request-config';
import { CompaniesByTypesProps } from 'request-config/company/company.types';
import { CompaniesByTypesResponse } from './companies-by-types.props';
import { QueryHookOptions } from 'hooks/react-query/react-query.props';
import { ApiResponse } from '../../../../common/interfaces';

export const useCompaniesByTypesQuery = (
  props: CompaniesByTypesProps,
  { options }: QueryHookOptions<ApiResponse<CompaniesByTypesResponse[]>, ApiResponse<CompaniesByTypesResponse[]>> = {}
) => {
  const { fetch } = useFetch<ApiResponse<CompaniesByTypesResponse[]>>({
    loadingKey: `companiesByTypes${JSON.stringify(props)}`,
    ...companyRequestConfig.companiesByTypes(props)
  });

  const { data, ...restQueryProps } = useQuery({
    queryKey: [CompanyQueryKeys.CompaniesByTypes, props],
    queryFn: () => fetch(),
    ...options
  });

  return { companiesByTypesQuery: data?.data?.data?.map(item => item.attributes) || [], ...restQueryProps };
};
